import { localStorage } from 'dash-ui';

export function downloadMedia(mediaIds: string[]): void {
  window.open(
    process.env['REACT_APP_REST'] +
      `/media/download?accessToken=${localStorage.getAccessToken()}&mediaIds=${JSON.stringify(
        mediaIds
      )}`
  );
}

export function downloadAllMediaInProperty(propertyId: string): void {
  window.open(
    process.env['REACT_APP_REST'] +
      `/media/download-all-media-in-property?accessToken=${localStorage.getAccessToken()}&propertyId=${propertyId}`,
    '_blank'
  );
}

export function downloadAllMediaInPortfolioMediaKit(portfolioId: string): void {
  window.open(
    process.env['REACT_APP_REST'] +
      `/media/download-all-media-in-media-kit?portfolioId=${portfolioId}`,
    '_blank'
  );
}
